var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerIcon(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7874 15.3931V18.3216C19.7874 18.71 19.6331 19.0825 19.3585 19.357C19.0839 19.6316 18.7114 19.7859 18.3231 19.7859H15.3945",
    stroke: "#64DFDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3945 2.21436H18.3231C18.7114 2.21436 19.0839 2.36863 19.3585 2.64323C19.6331 2.91784 19.7874 3.29028 19.7874 3.67864V6.60721",
    stroke: "#64DFDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21484 6.60721V3.67864C2.21484 3.29028 2.36912 2.91784 2.64372 2.64323C2.91833 2.36863 3.29077 2.21436 3.67913 2.21436H6.6077",
    stroke: "#64DFDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6077 19.7859H3.67913C3.29077 19.7859 2.91833 19.6316 2.64372 19.357C2.36912 19.0825 2.21484 18.71 2.21484 18.3216V15.3931",
    stroke: "#64DFDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9989 10.2678C12.6163 10.2678 13.9274 8.95659 13.9274 7.3392C13.9274 5.72181 12.6163 4.41064 10.9989 4.41064C9.38146 4.41064 8.07031 5.72181 8.07031 7.3392C8.07031 8.95659 9.38146 10.2678 10.9989 10.2678Z",
    fill: "#FAFAFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0007 12.4644C8.27156 12.4644 5.97834 14.331 5.32812 16.8572H16.6734C16.0232 14.331 13.7299 12.4644 11.0007 12.4644Z",
    fill: "#FAFAFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9989 10.2678C12.6163 10.2678 13.9274 8.95659 13.9274 7.3392C13.9274 5.72181 12.6163 4.41064 10.9989 4.41064C9.38146 4.41064 8.07031 5.72181 8.07031 7.3392C8.07031 8.95659 9.38146 10.2678 10.9989 10.2678Z",
    stroke: "#64DFDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0007 12.4644C8.27156 12.4644 5.97834 14.331 5.32812 16.8572H16.6734C16.0232 14.331 13.7299 12.4644 11.0007 12.4644Z",
    stroke: "#64DFDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcon);
export default __webpack_public_path__ + "static/media/CustomerIcon.e6fa577c687e38ee4b6e6d8d40263d7a.svg";
export { ForwardRef as ReactComponent };